import { formatHtml } from "@trumpf/ux.common-storybook";
import { html } from "lit";

const table = html`<table>
    <thead>
        <tr>
            <th>Modellvarianten des TruFiber S</th>
            <th>Laserleistungsbereich</th>
            <th>Wellenlänge</th>
            <th>Bauform</th>
            <th>Strahlqualität</th>
            <th>Anschlussleistung</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <div class="ux-iws-nb-data-table__title-cell">
                    <strong>TruFiber 3000 S</strong> (FD43)
                </div>
            </td>
            <td>
                60 W - 3000 W<br /><small>bei aktiver Leistungsregelung</small>
            </td>
            <td rowspan="4">1071 nm</td>
            <td rowspan="4">
                Breite: 600 mm<br />
                Höhe: 1280 mm<br />
                Tiefe: 980 mm<br /><br />
                Max. Anzahl Laserlichtkabel: 2
            </td>
            <td rowspan="4">2 mm * mrad</td>
            <td rowspan="4">Lorem Ipsum</td>
        </tr>
        <tr>
            <td>
                <div class="ux-iws-nb-data-table__title-cell">
                    <strong>TruFiber 4000 S</strong> (FD43)
                </div>
            </td>
            <td>
                80 W - 4000 W<br /><small>bei aktiver Leistungsregelung</small>
            </td>
        </tr>
        <tr>
            <td>
                <div class="ux-iws-nb-data-table__title-cell">
                    <strong>TruFiber 5000 S</strong> (FD43)
                </div>
            </td>
            <td>
                100 W - 5000 W<br /><small>bei aktiver Leistungsregelung</small>
            </td>
        </tr>
        <tr>
            <td>
                <div class="ux-iws-nb-data-table__title-cell">
                    <strong>TruFiber 6000 S</strong> (FD43)
                </div>
            </td>
            <td>
                120 W - 6000 W<br /><small>bei aktiver Leistungsregelung</small>
            </td>
        </tr>
    </tbody>
</table>`;

const Template = () =>
    html`<ux-iws-nb-data-table>
        <ux-table>${table}</ux-table>
    </ux-iws-nb-data-table>`;

export default {
    title: "Components/Nimbus Data Table",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-nb-data-table",
};

export const Default = {};
